import "./index.scss";

import { ArrowBackIos } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import { displayMobileNavBtn } from "components/shared/BPMobileNavBtn";
import StyledButton from "components/shared/StyledButton";
import { useIsMobile } from "hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import { toggleSettingsTab } from "store/settingsStore";
import { useAppDispatch } from "store/store";
/**
 * Render BP panel settings header
 */
interface IBPPanelHeader {
    panelTitle: string;
    /**
     * If the term has been edited
     */
    isEditing?: boolean;
    /**
     * On Mobile mode, if exit tab while editing, open block modal
     */
    openBlockModal?: () => void;
    /**
     * Submit form
     */
    submit?: () => void;
}

const BPPanelHeader = ({ panelTitle, isEditing, openBlockModal, submit }: IBPPanelHeader) => {
    const [t] = useTranslation();
    const { isMobile } = useIsMobile();
    const dispatch = useAppDispatch();

    const onExitTab = () => {
        if (isEditing) {
            displayMobileNavBtn(false);
            openBlockModal?.();
        } else dispatch(toggleSettingsTab(false));
    };

    return (
        <div className="bp-settings-panel-header">
            <div className="bp-settings-panel-header-left" onClick={() => isMobile && onExitTab()}>
                {isMobile && <ArrowBackIos sx={{ height: "18px", width: "18px" }} />}
                <h2>{panelTitle}</h2>
            </div>
            {isMobile && isEditing && (
                <StyledButton buttonType="primary" onClick={() => submit?.()}>
                    {" "}
                    <CheckIcon sx={{ height: "14px", width: "14px" }} />
                    {t("ConnectTitle.Save")}
                </StyledButton>
            )}
        </div>
    );
};

export default BPPanelHeader;
